/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Quote } from "./Quote";
import {
  QuoteFromJSON,
  QuoteFromJSONTyped,
  QuoteToJSON,
  QuoteToJSONTyped,
} from "./Quote";
import type { QuoteGroup } from "./QuoteGroup";
import {
  QuoteGroupFromJSON,
  QuoteGroupFromJSONTyped,
  QuoteGroupToJSON,
  QuoteGroupToJSONTyped,
} from "./QuoteGroup";

/**
 *
 * @export
 * @interface GroupedQuotes
 */
export interface GroupedQuotes {
  /**
   *
   * @type {QuoteGroup}
   * @memberof GroupedQuotes
   */
  quoteGroup: QuoteGroup;
  /**
   *
   * @type {Array<Quote>}
   * @memberof GroupedQuotes
   */
  quotes: Array<Quote>;
}

/**
 * Check if a given object implements the GroupedQuotes interface.
 */
export function instanceOfGroupedQuotes(value: object): value is GroupedQuotes {
  if (!("quoteGroup" in value) || value["quoteGroup"] === undefined)
    return false;
  if (!("quotes" in value) || value["quotes"] === undefined) return false;
  return true;
}

export function GroupedQuotesFromJSON(json: any): GroupedQuotes {
  return GroupedQuotesFromJSONTyped(json, false);
}

export function GroupedQuotesFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): GroupedQuotes {
  if (json == null) {
    return json;
  }
  return {
    quoteGroup: QuoteGroupFromJSON(json["quoteGroup"]),
    quotes: (json["quotes"] as Array<any>).map(QuoteFromJSON),
  };
}

export function GroupedQuotesToJSON(json: any): GroupedQuotes {
  return GroupedQuotesToJSONTyped(json, false);
}

export function GroupedQuotesToJSONTyped(
  value?: GroupedQuotes | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    quoteGroup: QuoteGroupToJSON(value["quoteGroup"]),
    quotes: (value["quotes"] as Array<any>).map(QuoteToJSON),
  };
}
